import React from 'react';

export default (props) => {
	return (
		<div className={"Filters__container__group" + (props.noBorder ? " Filters__container__group--no-border" : "") }>
			{ props.title ? (<div className="Filters__container__group__title">{props.title}</div>) : '' }
			{ props.children ? props.children : false }
		</div>
	);
}